// extracted by mini-css-extract-plugin
export default {"footer":"addressFooter_footer__b5fFc","actionButtons":"addressFooter_actionButtons__klWI-","counts":"addressFooter_counts__x04h4","createButton":"addressFooter_createButton__AODh7"};